"use client";
import useLocalizer from "@/hooks/useLocalizer";
import { cn } from "@/lib/utils/utils";
import Text from "./text";
import { TagSize } from "@/types/core";
import Flex from "../core/flex";
import { Activity } from "react";
type SectionTitleProps = {
  className?: string;
  title: string;
  subTitle?: string;
  subTitleClassName?: string;
  titleClassName?: string;
  description?: string | null;
  descriptionClassName?: string;
  lineStyle?: "1" | "2";
  lineCenter?: boolean;
  titleTag?: TagSize;
  descriptionTag?: TagSize;
  subTitleTag?: TagSize;
};
const SectionTitle: React.FC<SectionTitleProps> = ({
  className,
  title,
  titleClassName,
  subTitle,
  subTitleClassName,
  description,
  descriptionClassName,
  lineStyle = "1",
  lineCenter = false,
  titleTag = "h2",
  descriptionTag = "p",
  subTitleTag = "p",
}) => {
  const { isRtl } = useLocalizer();
  return (
    <Flex
      direction="col"
      spacing={{ all: 4 }}
      className={cn("relative", className)}
    >
      <Text as={titleTag} className={cn("text-primary", titleClassName)}>
        {title}
      </Text>
      <Activity mode={subTitle && subTitle != "" ? "visible" : "hidden"}>
        <Text
          as={subTitleTag}
          className={cn("text-foreground", subTitleClassName)}
        >
          {subTitle}
        </Text>
      </Activity>
      <Activity mode={description && description != "" ? "visible" : "hidden"}>
        <Text
          as={descriptionTag}
          className={cn("text-secondary", descriptionClassName)}
        >
          {description}
        </Text>
      </Activity>
      <div
        className={`section-line-${lineStyle} ${
          lineCenter ? "section-line-center" : ""
        }`}
        data-dir={isRtl ? "rtl" : "ltr"}
      />
    </Flex>
  );
};

export default SectionTitle;
